module.exports = __webpack_public_path__ + "img/100.58af58c8.jpg";